import React from 'react'

import './index.scss'

import Container from '../Container'

const Warning = ({ title, area, phone }) => (
  <Container>
    <div className="home-warning">
      <div className="home-warning__title"><p>{title}</p></div>
      <p>{area}</p>
      <p>{phone}</p>
    </div>
    <div className="home-warning__background">
      <div><span /></div>
      <div><span /></div>
      <div><span /></div>
      <div></div>
    </div>
  </Container>
)

export default Warning
